import {
    bestResolutionForBudget,
    clampResolutionToBudget,
    MAX_CANDLES,
} from '../../markets/components/charts/chartResolution';

export interface ResolutionOption {
    value: number;
    label: string;
}

export const RESOLUTION_OPTIONS: readonly ResolutionOption[] = [
    { value: 1, label: '1m' },
    { value: 5, label: '5m' },
    { value: 15, label: '15m' },
    { value: 30, label: '30m' },
    { value: 60, label: '1h' },
    { value: 120, label: '2h' },
    { value: 240, label: '4h' },
    { value: 360, label: '6h' },
    { value: 720, label: '12h' },
    { value: 1440, label: '1d' },
    { value: 10080, label: '1w' },
];

const AVAILABLE = RESOLUTION_OPTIONS.map(o => o.value);

export const MIN_COLUMN_PX = 1.5;
const MIN_COLUMNS = 60;

export function columnBudget(plotWidth: number): number {
    return Math.max(
        MIN_COLUMNS,
        Math.min(MAX_CANDLES, Math.floor(plotWidth / MIN_COLUMN_PX))
    );
}

export function pickResolution(
    range: readonly [Date, Date],
    plotWidth: number,
    requested: number | null
): number {
    const rangeMinutes = (range[1].getTime() - range[0].getTime()) / 60_000;
    const budget = columnBudget(plotWidth);
    if (requested === null) {
        return bestResolutionForBudget(rangeMinutes, AVAILABLE, budget);
    }
    return clampResolutionToBudget(rangeMinutes, requested, AVAILABLE, budget);
}

export function resolutionLabel(minutes: number): string {
    return RESOLUTION_OPTIONS.find(o => o.value === minutes)?.label ?? '';
}
